// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MHRg","buttons":"styles_buttons__gT5nW"};